module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/J7Ce0H/tc-custom/9781398479746.jpg?1705541262329",
      "alt": "This image is the cover for the book Panyin the Pangolin"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Panyin the Pangolin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Join Panyin, a brave and curious pangolin, on an exciting adventure filled with new friends and unexpected challenges in Panyin the Pangolin. Follow this rarely-seen mammal as he explores the plains, encountering the diverse and fascinating day-to-day lives of the animals that call it home. With vibrant illustrations and an engaging story, young readers will learn about the importance of protecting wildlife and the dangers of plastic pollution. Along the way, children will discover the importance of perseverance, creativity, and the power of community as Panyin faces his difficulties and finds a way to overcome them. This book is not only entertaining but also teaches valuable lessons to children and inspire them to care for the environment.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sahra Nur\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Inspired by nature and looking after the environment, Sahra Nur loves to entertain and motivate children to do good. Born in East Africa, Sahra visits the Horn to see the flora and fauna, especially an elephant calf she adopted two years ago. Panyin the Pangolin is her first book for children. Sahra enjoys the outdoors and painting landscape art in her spare time, as well as spending time with her family and Cece the cat.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0